import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Tag,  Button, Flex } from "antd";
import {
    InfoWindow,
    Marker,
    OverlayView,
} from '@react-google-maps/api';

// Components
import { PrimaryButton } from "../../../Decoration/Button";
import { ModalRemark } from "../NotificationsDrawer/remark";

// Constants
import { STATUS } from "../../../../constants/template";

// Redux Actions
import { reduxStoreWrapper } from "../../../../services/util/redux"
import {
    v3_vehicleLogs
} from '../../../../services/redux/actions'

const {
    unset_selected_event_log_data,
    update_event_log_info_request
} = v3_vehicleLogs

const {
    EVENT_TICKET_COLOR,
    EVENT_TICKET_TYPES_BY_CODES
} = STATUS

const EventInformationBox = ({
    mapRef
}) => {

    const dispatch = useDispatch()

    const selectedEventLog = useSelector(reduxStoreWrapper('vehicleEventLogs.selectedData'))
    const user = useSelector(reduxStoreWrapper('user'))
    const userRoles = useSelector(reduxStoreWrapper('userRoles.byID'))
    const loading = useSelector(reduxStoreWrapper('style.loading.vehicleEvent'))

    const [ showRemark, setShowRemark ] = useState(false)

    useEffect(() => {
        let zoom, location

        if(selectedEventLog.vid && selectedEventLog.lat && selectedEventLog.lon) {
            zoom = 15;
    
            location = {
                lat: parseFloat(selectedEventLog.lat),
                lng: parseFloat(selectedEventLog.lon),
            }
    
            if (mapRef) {
                mapRef.panTo(location);
                mapRef.setZoom(zoom);
            }
        }

    })

    const resolveHDLR = (remark) => {

        const { vid = '', eventTime = '', eventid = '' } = selectedEventLog || {}

        dispatch(update_event_log_info_request({ vid, eventid, remark, eventTime }, () => {
            dispatch(unset_selected_event_log_data());
            setShowRemark(false)
        }))
    }

    const getHelpHDLR = () => {

        const { name: uname, uroleid } = user
        const { plate, name: event, time } = selectedEventLog

        const tempText = `Hi I am ${uname}, as ${userRoles[uroleid]?.roleName || uroleid}. I need help for vehicle *${plate}* for event *${event}* at *${time}*`

        return window.open(`https://api.whatsapp.com/send?phone=60137439285&text=${encodeURIComponent(tempText)}`, '_blank')
    }

    return (
        selectedEventLog.vid
        &&
        <Marker>
            <InfoWindow
                zIndex = {1000}
                options = {{ disableAutoPan: true }}
                mapPaneName = {OverlayView.OVERLAY_MOUSE_TARGET}
                position = {{
                    lat: parseFloat(selectedEventLog.lat),
                    lng: parseFloat(selectedEventLog.lon)
                }}
                onCloseClick = {() => {
                    dispatch(unset_selected_event_log_data());
                }}
            >
                <div style={{ width: '20em'}}>
                <ModalRemark open={showRemark} loading={loading} onCancel={() => setShowRemark(false)} onOk={resolveHDLR}/>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
                        <h2>{selectedEventLog.name}</h2>
                        <div>
                            <Tag color={EVENT_TICKET_COLOR[EVENT_TICKET_TYPES_BY_CODES[selectedEventLog.type_rule]]}>{EVENT_TICKET_TYPES_BY_CODES[selectedEventLog.type_rule]}</Tag>
                        </div>
                    </div>
                    <p>Vehicle Plate: {selectedEventLog.plate}</p>
                    <p>Driver: {selectedEventLog.driver || '-'}</p>
                    <p>Coordinates: <span aria-hidden='true' className="ButtonLink">{selectedEventLog.lat}, {selectedEventLog.lon}</span></p>
                    <p>Created Date: {selectedEventLog.time}</p>
                    <Flex gap={5} justify="center" style={{ marginTop: '15px' }}>
                        <PrimaryButton loading={loading} onClick={() => setShowRemark(true)} style={{ height: '3em', width: '100%', display: 'block'}}>Resolve</PrimaryButton>
                        <Button style={{ backgroundColor: '#FF7800', color: '#fff', height: '3em', width: '100%', display: 'block' }} onClick={getHelpHDLR}>Get Help</Button>
                    </Flex>
                </div>
            </InfoWindow>
        </Marker>
    )
}

export default React.memo(EventInformationBox)